<template>
  <router-link
      :to="to"
      class="back-button"
      :class="`mb-${marginBottom}`">
    <i class="fa-solid fa-arrow-left back-icon"></i>

    <span class="back-text">{{ label }}</span>
  </router-link>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { piniaCompanySettingsStore } from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

defineProps({
  label: {
    type: String,
    required: true
  },
  to: {
    type: [String, Object],
    required: true
  },
  marginBottom: {
    type: [String, Number],
    default: 4
  }
});
</script>

<style scoped>
.back-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;

  align-self: center;
  width: fit-content;

  background-color: v-bind(companyBgColor);
  border: 1px solid v-bind(companyColor);
  color: v-bind(companyColor);

  padding: 5px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
}

.back-icon {
  font-size: 14px;
  color: v-bind(companyColor);
  transition: transform 0.2s ease-in-out;
}

.back-button:hover {
  filter: brightness(0.96);
  transform: translateY(-1px);
  text-decoration: none;
}

.back-button:hover .back-icon {
  transform: translateX(-4px);
}

.back-text {
  white-space: nowrap;
}

@media (max-width: 640px) {
  .back-button {
    width: 100%;
    justify-content: center;
  }
}
</style>